// Initialize carousel
var owl = $(".card-carousel").owlCarousel({
    loop: true,
    items: 1,
    navElement: "div",
    animateOut: "fadeOut",
    animateIn: "fadeIn",
    responsiveClass: true,
    autoHeight: true,
    responsive: {
        0: {
            dots: true,
            nav: false,
            mouseDrag: true,
            touchDrag: true,
        },
        960: {
            dots: false,
            nav: true,
            navText: ["keyboard_arrow_left", "keyboard_arrow_right"],
            mouseDrag: false,
            touchDrag: false,
        },
    },
});
